import { createEnum } from './enum-kit.js';
import { enumLabelMap, enumValues } from './utils.js';
export const paymentItemProfitLossTypeEnum = createEnum({
    INCOME: ['income', '收入', 'green'],
    EXPENSE: ['expense', '费用', 'orange'],
    NON_PROFIT_LOSS: ['non_profit_loss', '资金往来', 'blue'],
    UNCLASSIFIED: ['unclassified', '未分类', 'default'],
});
export const PAYMENT_ITEM_PROFIT_LOSS_TYPES = enumValues(paymentItemProfitLossTypeEnum);
export const PAYMENT_ITEM_PROFIT_LOSS_TYPE_LABEL_MAP = enumLabelMap(paymentItemProfitLossTypeEnum);
export const paymentItemApplicableDirectionEnum = createEnum({
    RECEIPT: ['receipt', '收款', 'green'],
    PAYMENT: ['payment', '付款', 'orange'],
    BOTH: ['both', '收付款', 'blue'],
});
export const PAYMENT_ITEM_APPLICABLE_DIRECTIONS = enumValues(paymentItemApplicableDirectionEnum);
export const PAYMENT_ITEM_APPLICABLE_DIRECTION_LABEL_MAP = enumLabelMap(paymentItemApplicableDirectionEnum);
export const paymentItemUsageEnum = createEnum({
    RECEIPT: ['receipt', '收款申请', 'green'],
    PAYMENT: ['payment', '付款申请', 'orange'],
    MANUAL_EXPENSE_ADJUSTMENT: [
        'manual_expense_adjustment',
        '手工费用调账',
        'purple',
    ],
});
export const PAYMENT_ITEM_USAGES = enumValues(paymentItemUsageEnum);
export const PAYMENT_ITEM_USAGE_LABEL_MAP = enumLabelMap(paymentItemUsageEnum);
//# sourceMappingURL=payment-item.js.map